import { humanFormat, humanNumber, formatNumber } from './numbers.js';

export function getFormatter(name) {
  return (value) => {
    switch (name) {
      case 'seriesLabelGet2':
        return value.value[2];
      case 'formatHumanCurrencyCents':
        return humanFormat('currency_cents', value);
      case 'formatHumanCurrency':
        return humanFormat('currency', value);
      case 'formatHumanNumber':
        return humanNumber(value);
      case 'formatPercent':
        return formatNumber('percent', value);
      default:
        return value;
    }
  };
}

export function replaceFormatters(options) {
  if (options?.yAxis?.axisLabel?.formatter &&
      typeof options.yAxis.axisLabel.formatter === 'string') {
    options.yAxis.axisLabel.formatter = getFormatter(options.yAxis.axisLabel.formatter);
  }

  if (Array.isArray(options?.series)) {
    for (const s of options.series) {
      if (s?.label?.formatter && typeof s.label.formatter === 'string') {
        s.label.formatter = getFormatter(s.label.formatter);
      }
    }
  }

  return options;
}
